import AmplitudeUtils from '../../utils/amplitude-utils';
import BaseMfaVerifyCustomizer from './base';

export default class MfaVerifyPasscodePhoneCustomizer extends BaseMfaVerifyCustomizer {
  primaryButtonClassName = 'fe_u_margin--bottom-small';

  primaryButtonOnClick = () => {
    const amplitudeEventPrefix = this.context.methodType === 'sms' ? 'SMS' : 'VoiceCall';
    AmplitudeUtils.logMfaChallengeEvent(`${amplitudeEventPrefix}::VerifyButtonClick`);
  };

  onInfoContainerLinkClick = () => {
    const amplitudeEvent = this.context.methodType === 'sms' ? 'SMS::ReSendCodeButtonClick' : 'VoiceCall::RedialButtonClick';
    AmplitudeUtils.logMfaChallengeEvent(amplitudeEvent);
  };

  async shouldCustomize() {
    return this.context.controller === 'mfa-verify-passcode' && this.context.authenticatorKey === 'phone_number';
  }
}
